import * as React from 'react';

export interface IconProps {
    size: null | string | number;
    className?: string;
    style?: any;
    wrapWithDiv?: boolean;
    alignCenter?: boolean;
    title?: string;
}

export function svgIconWrapper(Component: React.ComponentType<any>) {
    const DEFAULT_SIZE = 40;

    class Icon extends React.PureComponent<IconProps> {
        static defaultProps = {
            wrapWithDiv: true,
        };

        render() {
            const {size, className, style, wrapWithDiv, alignCenter, ...otherProps} = this.props;

            if (wrapWithDiv) {
                return (
                    <div
                        className={`react-icon svg-icon-container svg-${
                            // @ts-expect-error
                            Component.iconName || 'iconName-is-undefined'
                        } ${className || ''}`}
                        style={{
                            ...style,
                            height:
                                alignCenter && typeof size === 'number'
                                    ? `${size || DEFAULT_SIZE}px`
                                    : undefined,
                        }}
                        title={this.props.title}
                    >
                        <Component
                            width={size === null ? undefined : size || DEFAULT_SIZE}
                            height={size === null ? undefined : size || DEFAULT_SIZE}
                            {...otherProps}
                        />
                    </div>
                );
            }

            return (
                <Component
                    width={size === null ? undefined : size || DEFAULT_SIZE}
                    height={size === null ? undefined : size || DEFAULT_SIZE}
                    {...otherProps}
                />
            );
        }
    }

    return Icon;
}
